import { NgModule } from '@angular/core';

// This is here just to enforce structure for when it's needed
@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: []
})
export class AngularMaterialLibraryModule {


}
